export enum EDeviceType {
	BOT,
	DESKTOP,
	TABLET,
	MOBILE
}
